import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { StringMain, StringXSmall } from '@/components/Typography/Typography';

import css from './styles.module.scss';

interface OtherRewardItemProps {
  count: string | number;
  reward: string | number;
}

const OtherRewardItem: FC<OtherRewardItemProps> = ({ count, reward }) => {
  const { t } = useTranslation();

  return (
    <div className={css.otherReward}>
      <StringMain weight="bold" className="!text-white/60 !leading-none">
        {count}
      </StringMain>
      <StringXSmall className="!text-white/80 mt-[2px] !leading-none">
        {t('Rewards')}
      </StringXSmall>
      <span className="font-extrabold text-[20px] leading-none mt-2">
        ${reward}
      </span>
    </div>
  );
};

export { OtherRewardItem };
